<ll-toolnavbar>
    <plan_estudio-toolnavbar></plan_estudio-toolnavbar>
</ll-toolnavbar>
<ll-titulo>Plan de Estudio</ll-titulo>

<plan_estudio [planEstudioId]="planEstudioId"></plan_estudio>
